import { Box, Icon, Switch, Typography, useTheme } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';

interface LayerToggleItemProps {
  gridRow: string;
  gridColumn: string;
  icon: React.ReactNode;
  label: string;
  checked: boolean;
  onChange?: () => void;
  disabled?: boolean;
  activeColor?: string;
  sx?: SxProps<Theme>;
}

const LayerToggleItem = ({ gridRow, gridColumn, icon, label, checked, onChange, disabled, activeColor, sx }: LayerToggleItemProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        padding: theme.spacing(0.5, 0),
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
        gridRow,
        gridColumn,
        justifySelf: 'stretch',
        ...sx
      }}
    >
      <Box sx={{ display: 'flex', padding: theme.spacing(0.75, 2), alignItems: 'center', alignSelf: 'stretch', gap: theme.spacing(1.5), opacity: disabled ? 0.4 : 1 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          <Icon sx={{ color: checked && activeColor ? activeColor : 'action.active' }}>{icon}</Icon>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: theme.spacing(1), flex: '1 0 0' }}>
          <Typography variant="body3" color="text.primary" flex="1">
            {label}
          </Typography>
          <Switch checked={checked} onChange={disabled ? undefined : onChange} disabled={disabled} size="small" />
        </Box>
      </Box>
    </Box>
  );
};

export default LayerToggleItem;
